import { useIsMobile } from "@/hooks/useIsMobile";
import React from "react";
import { Modal } from "react-bootstrap";

interface props {
  isOpen: boolean;
  onClose?: () => void;
  children: React.ReactNode;
  fullScreen?: boolean;
  style?: React.CSSProperties;
  contentClassName?: string;
}
const PopUp: React.FC<props> = ({
  children,
  isOpen,
  onClose,
  fullScreen,
  style = {},
  contentClassName: contentClassNameProp,
}) => {
  const mobile = useIsMobile();

  // const mCLass = mobile ? "w-100" : "product-popup-container";
  const modalClassName = mobile
    ? fullScreen
      ? ""
      : "modal-as-swipeable-drawer drawer up-align"
    : "";
  const dialogClassName = !mobile ? "messagebox-dialog" : "";
  const contentClassName = mobile
    ? `dialog-swipeable-drawer ${contentClassNameProp}`
    : `pop-up-contents-reciving ${contentClassNameProp}`;

  return (
    <Modal
      centered={!mobile}
      fullscreen={fullScreen ? fullScreen : undefined}
      show={isOpen}
      onHide={onClose}
      className={modalClassName}
      dialogClassName={dialogClassName}
      contentClassName={contentClassName}
      style={mobile ? { zIndex: 9999, padding: 0, ...style } : { ...style }}
    >
      <div
        className="w-100"
        style={
          mobile ? { height: "90vh", overflow: "auto", paddingBottom: 25 } : {}
        }
      >
        {children}
      </div>
    </Modal>
  );
};
export default PopUp;
